import cn from './cn.js';

/**
 * EmptyState: shown when a list has no items (or a search returns nothing).
 */
export default function EmptyState({ icon: Icon, title, description, action, secondaryAction, className, compact = false, tone = 'neutral' }) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-white text-center',
        compact ? 'px-4 py-8' : 'px-6 py-14',
        className,
      )}
    >
      {Icon && (
        <span className={cn('mb-4 inline-flex items-center justify-center rounded-2xl', compact ? 'h-10 w-10' : 'h-12 w-12', tone === 'brand' ? 'bg-indigo-50 text-indigo-600' : 'bg-gray-100 text-gray-500')}>
          <Icon className={compact ? 'h-5 w-5' : 'h-6 w-6'} aria-hidden="true" />
        </span>
      )}
      {title && <h3 className="text-base font-semibold text-gray-900">{title}</h3>}
      {description && <p className="mt-1 max-w-md text-sm text-gray-500">{description}</p>}
      {(action || secondaryAction) && (
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          {secondaryAction}
          {action}
        </div>
      )}
    </div>
  );
}
